<template lang="pug">
page-home-layout
  filter-yellow(
    slot="search"
    route="events"
    :fields="filterFields"
    :values="filterValuesLocal"
    :nav="navSwitcher"
  )
  slider-default(
    slot="presentation"
    :items="slidesList"
    :path="{ name: 'blog' }"
  )
  catalog-list(
    :visible="isMounted"
    :items="eventsList"
    :doubler="isMounted ? doubler : null"
    :button-visible="true"
    :link-to="{ name: 'events' }"
    slot="events"
    title="Каталог программ"
  )
    div(slot="after")
      ext-button(
        :transparent="true"
        :factor="1.4"
        :fill="false"
        :to="showAllRoute"
        color="green"
        size="small"
      ) Показать все
  dashboard(slot="dashboard")
  router-view
</template>

<script>
import PageHomeLayout from '@/components/page/home';
import CatalogList from '@/components/parts/catalog/list';
import SliderDefault from '@/components/parts/slider/homepage';
import { Yellow as FilterYellow } from '@/components/parts/filter';
import ExtButton from '@/components/ext/Button.vue';
import mixinFilter, { FILTER_MUNITIPALITY_KEY } from '../mixin-filter.js';
import moduleShow from '@/mixins/moduleShow.js';

import createStoreModule from './store.js';
import Dashboard from '../../components/parts/dashboard/dashboard';

const STORE_MODULE_NAME = 'home';

export default {
  storeName: STORE_MODULE_NAME,
  storeRegister: createStoreModule,

  components: {
    Dashboard,
    PageHomeLayout,
    CatalogList,
    SliderDefault,
    FilterYellow,
    ExtButton,
  },

  mixins: [mixinFilter, moduleShow],

  asyncData({ store, route }) {
    return store.dispatch(`${STORE_MODULE_NAME}/init`, {
      events: {
        municipality_id: store.state.municipality,
      },
    });
  },

  data: () => ({ isMounted: false }),

  computed: {
    showAllRoute() {
      const { municipality } = this.$store.state;
      const result = { name: 'events' };
      if (municipality) {
        result.municipality = municipality;
      }
      return result;
    },

    selectedMunicipality() {
      return this.$store.state.municipality;
    },

    filterValuesLocal() {
      const {
        filterValues,
      } = this;
      return { ...filterValues };
    },

    navSwitcher() {
      return this.$options.filterNav.map((item, index) => {
        const { municipality } = this.filterValuesLocal;
        const selected =
          item.variant === 'catalog'
            ? ['events', 'home'].includes(this.$route.name)
            : this.$route.name === 'map';
        const result = { ...item, selected };
        if (municipality) {
          result.to.query = result.to.query
            ? { ...result.to.query, municipality }
            : { municipality };
        }
        return result;
      });
    },

    state() {
      return this.$store.state[STORE_MODULE_NAME];
    },

    formShitchMode() {
      return this.$route && this.$route.query && this.$route.query.mapView
        ? +this.$route.query.mapView
        : undefined;
    },

    slidesList() {
      const { slides } = this.state;
      return Array.isArray(slides)
        ? slides.map((item) => {
            return {
              ...item,
              to: {
                name: 'blog-article',
                params: {
                  id: item.id,
                },
              },
            };
          })
        : [];
    },

    eventsList() {
      const { events } = this.state;
      return events ? events.slice(0, 18) : [];
    },
  },

  mounted() {
    this.$nextTick(() => (this.isMounted = true));
  },

  methods: {
    doubler(index) {
      return (
        this.$mq === 'desktop' && (index % 6 === 0 || (index - 5) % 6 === 0)
      );
    },
  },

  metaInfo() {
    const { state, $store } = this;
    const [image] = state.slides;
    const thumb = image && image.thumb;
    const { logoImage, seoDescription, seoKeywords, seoTitle } =
      $store.state.regionProfile;
    return {
      title:
        seoTitle ||
        state.name ||
        'Центр опережающей профессиональной подготовки',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content:
            seoDescription || 'Центр опережающей профессиональной подготовки',
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content:
            seoKeywords || 'блог, цопп, профессиональная, подготовка, центр',
        },
        {
          vmid: 'og:title',
          property: 'og:title',
          content:
            seoTitle ||
            state.name ||
            'Центр опережающей профессиональной подготовки',
        },
        {
          vmid: 'og:description',
          property: 'og:description',
          content:
            seoDescription || 'Центр опережающей профессиональной подготовки',
        },
        {
          vmid: 'og:image',
          property: 'og:image',
          content: logoImage || thumb || '',
        },
      ],
    };
  },
};
</script>



// WEBPACK FOOTER //
// Home.vue?1d60b370